<template>
  <v-card class="beez-card">
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold">Support Tasks</v-toolbar-title>
    </v-toolbar>
    <v-flex v-if="can('TASK_SUPPORT')">
      <tasks taskType="support" :taskId="tab === supportTasks ? taskId : ''" />
    </v-flex>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Tasks from './Tasks'

export default {
  name: 'TaskReportHome',
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  components: { Tasks },
  data() {
    return {
      tab: 0,
      taskId: null,
      supportTasks: 0,
      approvedTasks: 1
    }
  },
  mounted() {
    if (this.$route.query.tab) {
      this.tab = parseInt(this.$route.query.tab)
    }
    if (this.$route.query.taskId) {
      this.taskId = this.$route.query.taskId
    }
  }
}
</script>

<style scoped></style>
